import React, { useState } from "react";
import { connect, useDispatch } from 'react-redux';
import { userActions } from '../../_actions';
import LoginJSON from './login.json'
import { useNavigate } from 'react-router';
import { Eye, EyeOff } from 'lucide-react';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [fieldslogin, setFieldsLogin] = useState({});
  const [errorslogin, setErrorsLogin] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const inputChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFieldsLogin(prevState => ({ ...prevState, [name]: value }));
    setErrorsLogin(prevState => ({ ...prevState, [name]: "" }));
  };

  const loginSubmit = (e) => {
    e.preventDefault();
    if (handleValidationLogin()) {
      const { userName, password } = fieldslogin;
      dispatch(userActions.login({ user_name: userName, passwd: password }, navigate));
    }
  };

  const handleValidationLogin = () => {
    let formIsValid = true;
    let errors = {};

    if (!fieldslogin.userName || fieldslogin.userName === "") {
      formIsValid = false;
      errors.userName = LoginJSON.ErrorMsg.userName;
    }

    if (!fieldslogin.password) {
      formIsValid = false;
      errors.password = LoginJSON.ErrorMsg.password;
    }

    setErrorsLogin(errors);
    return formIsValid;
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div className="overflow-hidden">
        <div className="bg-[#F5F6FA] relative">
          <div className="min-h-screen flex flex-col justify-center py-12 px-3 sm:px-6 lg:px-3 relative z-20">
            <div className="font-bold text-center mb-5 text-[##00923F] flex justify-center">
              <img src="/Images/logo-green.png" className="w-[125px]" alt="JBC"></img>
            </div>
            <div className=" mx-auto w-full  max-w-lg">
              <div className="bg-white p-6 shadow rounded-lg">
                <div className="sm:w-full sm:max-w-sm">
                  <h2 className="textcolor tracking-tighter mb-3 text-start text-[30px] leading-9 font-bold capitalize text-dark-400 tracking-widest">{LoginJSON.heading}</h2>
                </div>
                <div>
                  <p className="text-[#202224] mt-0 mb-4 text-center text-[13px] leading-9  capitalize text-dark-400 ">{LoginJSON.detail}</p>
                </div>
                <form autoComplete="off">
                  <div className="{otpSent?'disableArea':''}">
                    <p className="text-[#202224] mt-0 text-start text-sm leading-9  capitalize text-dark-400 ">{LoginJSON.label["enter-userName"]}</p>
                    <div className="mt-1  shadow-sm relative">
                      <input 
                        className={`px-3 py-2.5 border bg-white rounded-md text-base focus:border-green-600 focus:outline-none  w-full transition-all duration-150 ${!errorslogin["userName"] ? "border   placeholder-gray-500" : "border border-opacity-100 border-red-500 "}`}
                        id="userName" 
                        name="userName" 
                        placeholder="Enter Username" 
                        type="text" 
                        onChange={inputChange} 
                        autoComplete="email" 
                      />
                      {errorslogin["userName"] &&
                        <div className="invalid-feedback text-slate-900">
                          {errorslogin["userName"]}
                        </div>
                      }
                    </div>
                  </div>

                  <div className="mt-6">
                    <p className="text-[#202224] mt-0 text-start text-sm  capitalize text-dark-400 ">{LoginJSON.label["enter-password"]}</p>

                    <div className="mt-1 rounded-md shadow-sm relative">
                      <input 
                        className={`px-3 py-2.5 border bg-white rounded-md text-base focus:border-green-600 focus:outline-none  w-full transition-all duration-150  ${!errorslogin["password"] ? " placeholder-gray-500" : "border-opacity-100 border border-red-500 "}`}
                        id="password" 
                        name="password" 
                        placeholder="Password" 
                        type={showPassword ? "text" : "password"} 
                        onChange={inputChange} 
                      />
                      <button 
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 focus:outline-none"
                      >
                        {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                      </button>
                      {errorslogin["password"] &&
                        <div className="invalid-feedback text-slate-900">
                          {errorslogin["password"]}
                        </div>
                      }
                    </div>
                  </div>

                  <div className="mt-6 mx-auto py-6">
                    <button 
                      className="bgcolor w-full mx-auto flex justify-center py-3 capitalize px-2 border text-lg xl font-semibold rounded-lg bgbtn focus:outline-none transition duration-150 ease-in-out" 
                      type="submit" 
                      onClick={loginSubmit}
                    >
                      {LoginJSON.signin}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const { users } = state
  return {
    users
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Login)